export enum ContactTypeEnum {
    PERSON = 'person',
    ORGANIZATION = 'organization',
}
